module.exports = __webpack_public_path__ + "img/lv.51fd82ae.svg";